export default __webpack_public_path__ + "static/media/4.752d87e1.jpg";